/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewDataleak } from './CRSFSecReviewDataleak';
import {
    CRSFSecReviewDataleakFromJSON,
    CRSFSecReviewDataleakFromJSONTyped,
    CRSFSecReviewDataleakToJSON,
} from './CRSFSecReviewDataleak';

/**
 * 
 * @export
 * @interface CRSFSecReviewDataleaksPagedResponse
 */
export interface CRSFSecReviewDataleaksPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDataleaksPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDataleaksPagedResponse
     */
    page_size?: number;
    /**
     * 
     * @type {Array<CRSFSecReviewDataleak>}
     * @memberof CRSFSecReviewDataleaksPagedResponse
     */
    results?: Array<CRSFSecReviewDataleak>;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDataleaksPagedResponse
     */
    total?: number;
}

/**
 * Check if a given object implements the CRSFSecReviewDataleaksPagedResponse interface.
 */
export function instanceOfCRSFSecReviewDataleaksPagedResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFSecReviewDataleaksPagedResponseFromJSON(json: any): CRSFSecReviewDataleaksPagedResponse {
    return CRSFSecReviewDataleaksPagedResponseFromJSONTyped(json, false);
}

export function CRSFSecReviewDataleaksPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewDataleaksPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(CRSFSecReviewDataleakFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function CRSFSecReviewDataleaksPagedResponseToJSON(value?: CRSFSecReviewDataleaksPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(CRSFSecReviewDataleakToJSON)),
        'total': value.total,
    };
}

